import React from 'react';
import { commonStyles } from '../../styles/common';
import SectionHeading from '../ui/SectionHeading';

const Hero = () => {
  return (
    <section className={`${commonStyles.section} bg-white`}>
      <div className={commonStyles.container}>
        <SectionHeading
          title="Les Certificats d'Économies d'Énergie (CEE)"
          description="Un dispositif national pour encourager les économies d'énergie"
          centered
        />
        
        <div className="mt-8 prose max-w-none">
          <p className="text-lg text-gray-600 leading-relaxed">
            Les Certificats d'Économie d'Énergie (CEE) sont un dispositif mis en place par la loi POPE en 2005 
            pour encourager les économies d'énergie en France. Il impose aux grandes entreprises du secteur 
            de l'énergie une obligation de réduire la consommation énergétique de leurs clients.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;